import script from "./clear-draft-motion-button.vue?vue&type=script&lang=js"
export * from "./clear-draft-motion-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__